module.exports = __webpack_public_path__ + "img/Recognition@3x.7e13eedc.png";